import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import getBrowserHistory from 'yoda-core-components/lib/navigation/history/getBrowserHistory';
import classNames from 'classnames/bind';

import Icon from 'yoda-core-components/lib/components/Icon/Icon';

import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import ModalBox from 'yoda-core-components/lib/deprecated/ModalBox/ModalBox';
import ChatLine from '../../../../assets/svg/chat.svg';
import SiteComponent from '../../../SiteComponent/SiteComponent';
import MarketingOptInSection from '../../../MarketingOptInSection/MarketingOptInSection';
import actions from '../../../../actions/OrderAction';
import analyticsActions from '../../../../actions/AnalyticsAction';
import Link from '../../../Link/Link';
import footerConfig from '../../config';
import styles from './index.css';
import { selectDeviceType, selectFeatureFlags } from '../../../../selectors/ContextSelector';

const cx = classNames.bind(styles);
const {
    Validations: {
        emailRegex,
        phoneRegex,
        emptyErrorMessage,
        invalidErrorMessage,
        mobilePlaceHolder,
        errorMessage,
        formatPhoneRegex,
        desktopPlaceHolder,
    },
    SubscriptionLabels: { seeDetailsLink },
} = footerConfig;

export class YodaSubscription extends SiteComponent {
    static defaultProps = {
        deviceType: {},
        expandedFooter: false,
        offerMessageData: {},
        subscriptionStatus: {},
        featureFlags: {},
    };

    static propTypes = {
        deviceType: PropTypes.object,
        expandedFooter: PropTypes.bool,
        offerMessageData: PropTypes.object,
        subscriptionStatus: PropTypes.object,
        featureFlags: PropTypes.object,
    };

    constructor() {
        super();
        this.state = {
            isOfferMessageModalOpen: false,
            shouldInitiateRender: false,
            showInputError: false,
            setInputTypePhone: false,
            setInputTypeEmail: false,
            formatPhoneVal: '',
            inputErrorText: '',
            isSeeDetailsModalOpen: false,
            isPromotionSignUpClicked: false,
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.onChangeInputType = this.onChangeInputType.bind(this);
        this.subscribeWithPhoneOrEmail = this.subscribeWithPhoneOrEmail.bind(this);
        this.clearInputVal = this.clearInputVal.bind(this);
        this.subscribeBlock = this.subscribeBlock.bind(this);
    }

    unmount = null;

    componentDidMount() {
        this.unmount = getBrowserHistory().listen(() => {
            this.setState({
                showInputError: false,
                inputErrorText: '',
            });
        });
    }

    componentWillUnmount() {
        if (this.unmount) {
            this.unmount();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.subscriptionStatus.from === 'footer' &&
            nextProps.subscriptionStatus.isSuccess
        ) {
            if (this.state.showInputError) {
                this.setState({
                    showInputError: false,
                    inputErrorText: '',
                });
            }

            const optinType = nextProps.subscriptionStatus?.type === 'MOBILE' ? 'sms' : 'email';
            this.props.actions.subscriptionSuccessAnalytics({
                optinType,
                source: 'page footer',
            });

            this.toggleModal('isOfferMessageModalOpen', true);
        } else if (
            nextProps.subscriptionStatus.from === 'footer' &&
            !nextProps.subscriptionStatus.isSuccess
        ) {
            this.setState({
                showInputError: true,
                inputErrorText: errorMessage,
            });
            this.props.actions.triggerFormError([
                {
                    errorDescription: errorMessage,
                },
            ]);
        }
        this.setState({ isPromotionSignUpClicked: false });
    }

    toggleModal(modalType, toggle) {
        this.setState({ [modalType]: toggle });
    }

    onChangeInputType(event) {
        const emailPattern = emailRegex;
        const phonePattern = phoneRegex;
        const inputStr = event;
        const formattedPhone = inputStr.replace(formatPhoneRegex, '$1-$2-$3');
        if (phonePattern.test(formattedPhone)) {
            this.setState({ setInputTypePhone: true });
            this.setState({ formatPhoneVal: formattedPhone });
        } else {
            this.setState({ setInputTypePhone: false });
            this.setState({ formatPhoneVal: '' });
        }
        if (emailPattern.test(inputStr)) {
            this.setState({ setInputTypeEmail: true });
        } else {
            this.setState({ setInputTypeEmail: false });
        }
    }

    subscribeWithPhoneOrEmail() {
        const emailPattern = emailRegex;
        const phonePattern = phoneRegex;
        const inputStr = this.phoneInput.value;
        const formattedPhoneNum = inputStr.replace(formatPhoneRegex, '$1-$2-$3');
        const data = {
            type: this.state.setInputTypeEmail ? 'EMAIL' : 'MOBILE',
            value: this.phoneInput.value,
        };
        if (this.phoneInput.value.length === 0) {
            this.setState({
                showInputError: true,
                inputErrorText: emptyErrorMessage,
            });
            this.props.actions.triggerFormError([
                {
                    errorDescription: emptyErrorMessage,
                },
            ]);
        } else if (
            emailPattern.test(formattedPhoneNum) ||
            phonePattern.test(this.phoneInput.value)
        ) {
            this.setState(
                {
                    showInputError: false,
                    inputErrorText: '',
                    isPromotionSignUpClicked: true,
                },
                () => {
                    this.props.actions.optin(data);
                }
            );
        } else {
            this.setState({
                showInputError: true,
                inputErrorText: invalidErrorMessage,
            });
            this.props.actions.triggerFormError([
                {
                    errorDescription: invalidErrorMessage,
                },
            ]);
        }
        this.toggleModal('isOfferMessageModalOpen', false);
    }

    clearInputVal() {
        this.setState({
            setInputTypeEmail: false,
            setInputTypePhone: false,
            formatPhoneVal: '',
        });
    }

    subscribeBlock() {
        let inputPlaceholder;
        let inputType = 'text';
        const { isSuccess = false } = this.props.subscriptionStatus;
        const {
            SubscriptionLabels: {
                seeDetails = '',
                textAlerts = '',
                signUpButton = '',
                signUpMessage = '',
                alertMessage = '',
            } = {},
        } = this.props.offerMessageData;
        if (this.props.deviceType.isMobile) {
            inputPlaceholder = mobilePlaceHolder;
        } else {
            inputPlaceholder = desktopPlaceHolder;
        }
        if (this.state.setInputTypeEmail) {
            inputType = 'email';
        }
        if (this.state.setInputTypePhone) {
            inputType = 'tel';
        }
        // Styling
        const subscriptionWrapperStyle = dt([
            'lg:pt-0',
            'lg:mb-2',
            'lg:pr-9',
            'lg:pl-8',
            'lg:mt-6',
            'lg:max-w-[684px]',
            'lg:w-[33.2%]',
            'lg:inline-block',
            'lg:align-top',
            'sm:my-0',
            'sm:py-4',
            'sm:pb-0',
            'sm:w-auto',
            'sm:px-6',
            'sm:block',
            'sm:!mx-auto',
        ]);
        const signInButtonStyle = dt([
            'h-12',
            'border',
            'border-solid',
            'border-brand-red',
            '!px-0',
        ]);
        const buttonWrapStyle = dt(['align-bottom']);
        const subsTitleStyle = dt([
            'font-semibold',
            'text-small',
            'leading-5',
            'text-center',
            'text-black',
            'pb-4',
        ]);
        const anchorStyle = dt([
            'text-gray-70',
            'text-xsmall',
            'leading-4',
            'font-normal',
            'underline',
            'text-center',
        ]);
        const subscriptionTermsStyle = dt([
            'font-normal',
            'text-xsmall',
            'text-center',
            'mt-1',
            'w-full',
            'text-gray-70',
            'tracking-normal',
        ]);
        const iconBlockStyle = dt(['text-center', 'mb-2', 'flex', 'justify-center']);
        const errorBorderStyle = dt(['border-2', 'border-solid', 'border-error-border']);
        const errorBlockStyle = dt([
            'text-error-border',
            'text-small',
            'lg:w-[20.438rem]',
            'md:w-[20.438rem]',
            'sm:w-[20.438rem]',
            'py-[5px]',
            'my-0',
            'mx-auto',
        ]);

        const subscribeStyle = dt([
            'bg-white',
            'rounded-l-lg',
            'shadow-none',
            'border',
            'border-solid',
            'border-gray-60',
            'border-r-0',
            'text-black',
            'h-12',
            'box-border',
            'italic',
        ]);
        const seeDetailsPopupStyle = dt(['block', 'md:pt-2', 'sm:pt-2']);

        // Styling
        return this.props.expandedFooter ? (
            <div
                data-automation-id="subscription-wrapper"
                className={`${styles.subscriptionWrapper} ${subscriptionWrapperStyle}`}
            >
                <ul data-automation-id="footer-block-subscribe" className={styles.containerWidth}>
                    <li className={styles.subscriptionRow}>
                        <div className={cx('iconBlock', iconBlockStyle)}>
                            <Icon
                                iconType="svg"
                                classNames="icon"
                                viewBox="0 0 40 40"
                                width="40px"
                                height="40px"
                                automationId="footer-error-icon"
                                pathClassName={styles.chatLine}
                            >
                                <ChatLine />
                            </Icon>
                        </div>
                        <div
                            data-automation-id="promo-title"
                            className={`${styles.subsTitle} ${subsTitleStyle}`}
                        >
                            {signUpMessage}
                        </div>
                        <MarketingOptInSection
                            data-automation-id="promo-input"
                            optDataId="deals-tel-txt-box"
                            btnDataId="deals-tel-btn"
                            type="text"
                            placeholder={inputPlaceholder}
                            customClass={styles.subscribeMain}
                            customInputWrapperClass={styles.subscribeInputWrapper}
                            customInputWithIconClass={styles.subscribeInputWithIcon}
                            customInputClass={`${
                                this.state.showInputError ? errorBorderStyle : ''
                            } ${subscribeStyle}`}
                            buttonClass={signInButtonStyle}
                            submitCallback={this.subscribeWithPhoneOrEmail}
                            isSuccess={isSuccess}
                            handleClearInputVal={this.clearInputVal}
                            onChangeCallback={this.onChangeInputType}
                            refCallback={(ref) => {
                                this.phoneInput = ref;
                            }}
                            deviceType={this.props.deviceType}
                            showInputPhoneIcon={inputType === 'tel'}
                            showInputEmailIcon={inputType === 'email'}
                            buttonWrap={buttonWrapStyle}
                            formattedPhoneNum={this.state.formatPhoneVal}
                            isPromotionSignUpClicked={this?.state?.isPromotionSignUpClicked}
                        >
                            {signUpButton}
                        </MarketingOptInSection>
                        {this.state.showInputError ? (
                            <div className={errorBlockStyle}>
                                <span className={styles.errorTextBlock}>
                                    {this.state.inputErrorText}
                                </span>
                            </div>
                        ) : null}
                    </li>
                    <li className={`${styles.subscriptionTerms} ${subscriptionTermsStyle}`}>
                        {textAlerts}
                        {alertMessage}
                        &nbsp;
                        <div className={dt(['flex', 'justify-center', 'items-end'])}>
                            <Link
                                className={cx(
                                    'anchor',
                                    'seeDetailsPopup',
                                    anchorStyle,
                                    seeDetailsPopupStyle
                                )}
                                id="seeDetailsModal"
                                data-automation-id="seedetails-modal"
                                href={seeDetailsLink || '#'}
                            >
                                {seeDetails}
                            </Link>
                            .
                        </div>
                    </li>
                </ul>
            </div>
        ) : (
            ''
        );
    }

    render() {
        const {
            featureFlags: { enableIrisFooterApi = true },
            deviceType: { isDesktop = true },
            offerMessageData: {
                OfferMessage: { title = '', Description = '' } = {},
                TermsLegal = [],
                Privacy = [],
                SubscriptionLabels: { seeDetailsMore = '', done = '' } = {},
            } = {},
        } = this.props;
        const linkUrlTermsAndConditionSms =
            isDesktop || enableIrisFooterApi
                ? TermsLegal[3]?.linkPath
                : TermsLegal[3]?.linkPathMobile;
        const linkUrlTermsAndConditionEmail =
            isDesktop || enableIrisFooterApi
                ? TermsLegal[4]?.linkPath
                : TermsLegal[4]?.linkPathMobile;
        const linkUrlPrivacy =
            isDesktop || enableIrisFooterApi ? Privacy[0].linkPath : Privacy[0].linkPathMobile;
        // Styling
        const suscriptionStyleMoreStyle = dt([
            'font-normal',
            'lg:text-normal',
            'md:text-sm',
            'sm:text-sm',
            'text-gray-70',
        ]);
        // Styling
        return (
            <>
                {this.subscribeBlock()}
                <ModalBox
                    showModal={this.state.isOfferMessageModalOpen}
                    onClose={() => this.toggleModal('isOfferMessageModalOpen', false)}
                    defaultHeader
                    modalTitleTheme={`${cx('modalTitle')} ${dt([
                        'mb-2',
                        'text-left',
                        'text-black',
                        'text-2xlarge',
                    ])}`}
                    title={title}
                    modalTheme={styles.customModalWrapper}
                    automationId="footer-offer-message-popup"
                >
                    <div
                        className={`${cx('customModalContent', 'customModalOfferMessage')} ${dt([
                            'font-normal',
                        ])}`}
                    >
                        <div data-automation-id="footer-message-body">
                            <p
                                className={dt([
                                    'text-base',
                                    'pt-0',
                                    'pr-0',
                                    'leading-normal',
                                    'text-black',
                                ])}
                            >
                                {Description}
                            </p>
                        </div>
                        <button
                            id="closeModalButton"
                            className={dt([
                                'text-center',
                                'mt-4',
                                'mb-0',
                                'mx-auto',
                                'block',
                                'sm:w-[200px]',
                                'bg-brand-red',
                                'shadow-elevation1',
                                'text-white',
                                'h-12',
                                'rounded-sm',
                                'sm:mt-[30px]',
                                'font-normal',
                                'text-base',
                            ])}
                            onClick={() => this.toggleModal('isOfferMessageModalOpen', false)}
                        >
                            {done}
                        </button>
                    </div>
                </ModalBox>
            </>
        );
    }
}

export const mapStateToProps = (store) => ({
    subscriptionStatus: store.optin,
    deviceType: selectDeviceType(store),
    featureFlags: selectFeatureFlags(store),
});

export const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(Object.assign(analyticsActions, actions), dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(YodaSubscription);
